import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-site-passthrough-mode-label',
  template: `<span class="label passthrough">{{ 'Site.passthroughMode.label' | translate }}</span>`,
  styles: `
    .label {
      &.passthrough {
        background-color: #333;
      }
    }
  `,
  imports: [TranslatePipe],
})
export class SitePassthroughModeLabelComponent {}
